<template>
  <div class="mypage-favorite-player-link-section">
    <h3 class="mypage-favorite-player-link-section__title">
      {{ $t('MypagePage.MypageTopPage.favoritePlayer') }}
    </h3>

    <div class="mypage-favorite-player-link-section__content">
      <div class="mypage-favorite-player-link-section__selected">
        <player-card-parts :name="name" :img="img" />
      </div>

      <atom-router-button
        v-if="enabledSelect"
        class="mypage-favorite-player-link-section__link"
        :to="'/mypage/favorite-player'"
        :linkText="$t('MypagePage.MypageTopPage.favoritePlayerChange')"
        colorType="tertiary"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import PlayerCardParts from '@/components/common/card/PlayerCardParts.vue'
import AtomRouterButton from '@/components/atoms/AtomRouterButton.vue'

/**
 * マイページ: トップ お気に入り選手 セクション
 * todo: 選手データ受渡
 */
export default defineComponent({
  name: 'MypageFavoritePlayerLinkSection',
  components: {
    PlayerCardParts,
    AtomRouterButton,
  },
  props: {
    /**
     * お気に入り選手名
     */
    name: {
      type: String,
      required: true,
    },
    /**
     * お気に入り選手画像
     */
    img: {
      type: String,
    },
    /**
     * 選択変更有効化
     */
    enabledSelect: {
      type: Boolean,
      default: true,
    },
  },
  methods: {},
})
</script>

<style lang="scss" scoped>
.mypage-favorite-player-link-section {
  width: 100%;
  margin-bottom: 24px;

  &__title {
    padding: 0 16px;
    margin-bottom: 8px;
    text-align: left;
    @include fontSetTextSmall(12);

    line-height: 1.67;
    color: $gray50;
  }

  &__content {
    background: $white;
  }

  &__selected {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    padding: 12px 16px;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }

  &__link {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 0;
    color: $black80;
  }
}

@media screen and (min-width: $responsiveMypageMaxWidth) {
  .mypage-favorite-player-link-section__content {
    border-left: 1px solid rgba(0, 0, 0, 0.1);
    border-right: 1px solid rgba(0, 0, 0, 0.1);
  }
}
</style>
